export default {
  computed: {
    firstNameError() {
      if (this.$v.internalValue.firstName.required === false) {
        return 'required'
      } else if (this.$v.internalValue.firstName.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.firstName.nameAlphaNumeric === false) {
        return 'only letters, spaces, *, -, and upto 4 digits allowed'
      }
    },
    middleInitialError() {
      if (this.$v.internalValue.middleInitial.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    lastNameError() {
      if (this.$v.internalValue.lastName.required === false) {
        return 'required'
      } else if (this.$v.internalValue.lastName.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.lastName.nameAlphaNumeric === false) {
        return 'only letters, spaces, numbers, *, and - allowed'
      }
    },
    suffixError() {
      if (this.$v.internalValue.suffix.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    emailError() {
      if (this.$v.internalValue.email.email === false) {
        return 'Not a valid email address'
      } else if (this.$v.internalValue.email.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    ssnError() {
      if (this.$v.internalValue.ssn.$model.length > 0) {
        if (
          this.$v.internalValue.ssn.fourOrNineDigitsLong === false &&
          this.$v.internalValue.ssn.$dirty
        ) {
          return '4 or 9 digits long'
        }
      }
    },
    dobError() {
      if (this.$v.internalValue.dob.required === false) {
        return 'required'
      }
    },
    genderError() {
      if (this.$v.internalValue.gender.required === false) {
        return 'required'
      }
    },
    clientHealthIdError() {
      if (this.$v.internalValue.clientHealthId.required === false) {
        return 'required'
      } else if (this.$v.internalValue.clientHealthId.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.clientHealthId.alphaNum === false) {
        return 'alphanumeric characters only'
      }
    },
    eyemedIdError() {
      if (this.$v.internalValue.clientMemberId.required === false) {
        return 'required'
      }
    },
    fileBoundIdError() {
      if (this.$v.internalValue.fileBoundId.required === false) {
        return 'required'
      } else if (this.$v.internalValue.fileBoundId.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.fileBoundId.alphaNum === false) {
        return 'alphanumeric characters only'
      } else if (this.$v.internalValue.fileBoundId.fileBoundIdValidation === false) {
        return 'alphanumeric or | character only'
      }
    },
    effectiveDateError() {
      if (this.$v.internalValue.effectiveDate.required === false) {
        return 'required'
      }
    },
    termDateError() {
      if (this.$v.internalValue.termDate.required === false) {
        return 'required'
      }
    },
    relationshipError() {
      if (this.$v.internalValue.relationship.required === false) {
        return 'required'
      }
    },
    planIdError() {
      if (this.$v.internalValue.planId.required === false) {
        return 'required'
      }
    },
    classIdError() {
      if (this.$v.internalValue.classId.required === false) {
        return 'required'
      }
    },
    groupCkError() {
      if (this.$v.internalValue.groupCk.required === false) {
        return 'required'
      }
    },
    parentGroupCkError() {
      if (this.$v.internalValue.parentGroupCk.required === false) {
        return 'required'
      }
    },
    subGroupCkError() {
      if (this.$v.internalValue.subGroupCk.required === false) {
        return 'required'
      }
    },
    divisionCodeError() {
      if (this.$v.internalValue.divisionCode.required === false) {
        return 'required'
      } else if (this.$v.internalValue.divisionCode.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.benefitOption.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    locationCodeError() {
      if (this.$v.internalValue.locationCode.required === false) {
        return 'required'
      } else if (this.$v.internalValue.locationCode.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.locationCode.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    companyCodeError() {
      if (this.$v.internalValue.companyCode.required === false) {
        return 'required'
      } else if (this.$v.internalValue.companyCode.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.companyCode.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },

    benefitOptionError() {
      if (this.$v.internalValue.benefitOption.required === false) {
        return 'required'
      } else if (this.$v.internalValue.benefitOption.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.benefitOption.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    clientGroupNumberError() {
      if (this.$v.internalValue.clientGroupNumber.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.clientGroupNumber.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    reportingCode1Error() {
      if (this.$v.internalValue.reportingCode1.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.reportingCode1.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    reportingCode2Error() {
      if (this.$v.internalValue.reportingCode2.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.reportingCode2.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    reportingCode3Error() {
      if (this.$v.internalValue.reportingCode3.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.reportingCode3.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    reportingCode4Error() {
      if (this.$v.internalValue.reportingCode4.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.reportingCode4.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    },
    reportingCode5Error() {
      if (this.$v.internalValue.reportingCode5.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.$v.internalValue.reportingCode5.requireTriggerToChangeField === false) {
        return 'must change effective date, term date, subgroup, class or plan'
      }
    }
  }
}
